import { useConst } from '@chakra-ui/react';
import QuoteApi from './quoteApi';
import type { IQuoteApi } from './quoteApi';

export const useQuoteApi = (): IQuoteApi => {
  return useConst(QuoteApi);
};
